/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {startSupportFlow} from '../api'

export const useMutationStartSupportFlow = createReactQueryMutationHook('startSupportFlow', startSupportFlow)
